import * as stylex from '@stylexjs/stylex';
import { theme } from 'trellis-theming/modern-theme.stylex';
import { theme as experimentalTheme } from 'trellis-theming/experimental-theme.stylex';
export const linkTextDecoration = {
  default: {
    textDecorationColor: "xgp0vme xn663l xc5jyd1 xw4jdxl",
    textDecorationLine: "x87d256 xdro10g xllw4zm x173tfty",
    textUnderlineOffset: "xph6j4w xxhvixc xjlatkw xynar7k",
    $$css: true
  },
  disabled: {
    textDecorationColor: "x1dodfyx",
    textDecorationLine: "x87d256",
    textUnderlineOffset: "xph6j4w",
    $$css: true
  }
};